import { AppShell as MantineAppShell } from "@mantine/core";
import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { PersistentHeroBackdrop } from "@/components/three/PersistentHeroBackdrop";

/**
 * Top-level shell: header + main area + footer. Children render without a
 * horizontal container so routes can either use PageContainer for normal
 * padded content or render a full-bleed section (home hero) that breaks
 * past the viewport edges.
 */
export function AppShell({ children }: { children: ReactNode }) {
  return (
    <MantineAppShell header={{ height: 64 }} padding={0} withBorder={false}>
      <MantineAppShell.Header
        style={{
          background: "rgba(13, 14, 31, 0.18)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          borderBottom: "none",
        }}
      >
        <Header />
      </MantineAppShell.Header>
      {/* paddingTop: 0 strips Mantine's auto header-offset so the home page
          hero can attach to the very top of the viewport. Non-hero routes
          compensate inside PageContainer. position: relative anchors the
          persistent hero video layer below. */}
      <MantineAppShell.Main style={{ paddingTop: 0, position: "relative" }}>
        {/* One persistent <video> for every hero route — mounted once here so
            it never remounts (and never reflashes its poster) on navigation.
            Sized per route via the route handle; see PersistentHeroBackdrop. */}
        <PersistentHeroBackdrop />
        {/* Route content + footer stack above the video (zIndex 1). The video
            layer is height-bounded to the hero band, so everything below the
            hero sits over the page background just as before. */}
        <div style={{ position: "relative", zIndex: 1 }}>
          {children}
          <Footer />
        </div>
      </MantineAppShell.Main>
    </MantineAppShell>
  );
}
